"use strict";
export const PRICE = {
  LUNCH_DRINK: 38,
  LUNCH_1: 100,
  LUNCH_2: 115,
  LUNCH_3: 130,
  COMBI_VEGI: 190,
  COMBI_SAKANA: 280,
  COMBI_KAISEN: 300,
};

export const MENU_CATEGORIES = {
  KITCHEN: { HE: "מטבח", EN: "kitchen" },
  SUSHI: { HE: "סושי", EN: "sushi" },
  LUNCH: { HE: "עסקיות", EN: "lunch" },
  BEVERAGES: { HE: "משקאות", EN: "beverages" },
};

export const MENU_CATEGORIES_LIST = ["KITCHEN", "SUSHI", "LUNCH", "BEVERAGES"];

export const NAV_ITEMS = {
  APPETIZERS: {
    HE: "ראשונות",
    EN: "appetizers",
    hash: "appetizers",
  },
  MAIN_DISHES: {
    HE: "עיקריות",
    EN: "main dishes",
    hash: "mainDishes",
  },
  DESSERTS: {
    HE: "קינוחים",
    EN: "desserts",
    hash: "desserts",
  },
  SASHIMI: {
    HE: "סשימי / ניגירי",
    EN: "sashimi / nigiri",
    hash: "seshimi",
  },
  INARI: {
    HE: "אינרי / גונקן",
    EN: "inari / gunkan",
    hash: "inari",
  },
  HOSOMAKI: {
    HE: "מאקי",
    EN: "hosomaki",
    hash: "hosomaki",
  },
  TEMAKI: {
    HE: "קונוסים",
    EN: "temaki",
    hash: "temaki",
  },
  IRODORI: {
    HE: "אינסייד אאוט",
    EN: "irodori",
    hash: "irodori",
  },
  COMBINATIONS: {
    HE: "קומבינציות",
    EN: "combinations",
    hash: "combinations",
  },
  LUNCH1: {
    HE: `עסקית ${PRICE.LUNCH_1}`,
    EN: `lunch ${PRICE.LUNCH_1}`,
    hash: "lunch1",
  },
  LUNCH2: {
    HE: `עסקית ${PRICE.LUNCH_2}`,
    EN: `lunch ${PRICE.LUNCH_2}`,
    hash: "lunch2",
  },
  LUNCH3: {
    HE: `עסקית ${PRICE.LUNCH_3}`,
    EN: `lunch ${PRICE.LUNCH_3}`,
    hash: "lunch3",
  },
  WINE: {
    HE: "יינות",
    EN: "wine",
    hash: "wine",
  },
  SAKE: {
    HE: "סאקה ובירות",
    EN: "sake & beer",
    hash: "sake",
  },
  COCKTAILS: {
    HE: "קוקטיילים",
    EN: "cocktails",
    hash: "cocktails",
  },
  SOFT_DRINKS: {
    HE: "שתייה קלה",
    EN: "soft drinks",
    hash: "softDrinks",
  },
  SPIRITS: {
    HE: "אלכוהול",
    EN: "spirits",
    hash: "spirits",
  },
  SPECIALS: {
    HE: "ספיישלים",
    EN: "specials",
    hash: "specials",
  },
  LUNCH_ONLY: {
    HE: "רק בעסקיות",
    EN: "Only in lunch",
    hash: "lunch",
  },
  NO_ACTIVE: {
    HE: "מנות לא פעילות",
    EN: "No active",
    hash: "noActive",
  },
  FAVORITES: {
    HE: 'המועדפים<i class="fas fa-heart favorite-btn-heart-HE"></i>',
    EN: 'favorites <i class="fas fa-heart favorite-btn-heart-EN"></i>',
    hash: "favorites",
  },
};

export const NAV_CATEGORIES_MENU = {
  KITCHEN: [NAV_ITEMS.APPETIZERS, NAV_ITEMS.MAIN_DISHES, NAV_ITEMS.DESSERTS],
  SUSHI: [
    NAV_ITEMS.SASHIMI,
    NAV_ITEMS.INARI,
    NAV_ITEMS.HOSOMAKI,
    NAV_ITEMS.TEMAKI,
    NAV_ITEMS.IRODORI,
    NAV_ITEMS.COMBINATIONS,
  ],
  LUNCH: [NAV_ITEMS.LUNCH1, NAV_ITEMS.LUNCH2, NAV_ITEMS.LUNCH3],

  BEVERAGES: [
    NAV_ITEMS.WINE,
    NAV_ITEMS.SAKE,
    NAV_ITEMS.COCKTAILS,
    NAV_ITEMS.SOFT_DRINKS,
    NAV_ITEMS.SPIRITS,
  ],
};

export const SPECIAL_NAV_ITEMS = [
  NAV_ITEMS.SPECIALS,
  NAV_ITEMS.LUNCH_ONLY,
  NAV_ITEMS.NO_ACTIVE,
  NAV_ITEMS.FAVORITES,
];

export const MENU_ITEMS_ORDER = [
  NAV_ITEMS.APPETIZERS,
  NAV_ITEMS.MAIN_DISHES,
  NAV_ITEMS.DESSERTS,
  NAV_ITEMS.SASHIMI,
  NAV_ITEMS.INARI,
  NAV_ITEMS.HOSOMAKI,
  NAV_ITEMS.TEMAKI,
  NAV_ITEMS.IRODORI,
  NAV_ITEMS.COMBINATIONS,
  NAV_ITEMS.WINE,
  NAV_ITEMS.SAKE,
  NAV_ITEMS.COCKTAILS,
  NAV_ITEMS.SOFT_DRINKS,
  NAV_ITEMS.SPIRITS,
  NAV_ITEMS.LUNCH1,
  NAV_ITEMS.LUNCH2,
  NAV_ITEMS.LUNCH3,
  NAV_ITEMS.SPECIALS,
];

export const NAV_CONFIG_ITEMS = [
  { label: "להציג ספיישלים על ההתחלה", id: "isSpecialsFirstPage" },
  { label: "לפתוח תפריט על ההתחלה", id: "openMenuOnStart" },
];
